package com.eladfinish.bible.contest.features.teruma

import com.eladfinish.bible.contest.data.AboutTerumaConfig
import com.eladfinish.bible.contest.features.installTime.domain.model.TimeGateResult
import com.eladfinish.bible.contest.features.installTime.domain.usecase.TimeGateUseCase
import com.eladfinish.bible.contest.repository.remoteConfig.RemoteConfig
import com.eladfinish.bible.contest.usecase.GetRemoteConfigObjectUseCase

class ResolveAboutTerumaUseCase(
    private val getRemoteConfigObjectUseCase: GetRemoteConfigObjectUseCase,
    private val timeGateUseCase: TimeGateUseCase,
) {

    operator fun invoke(): AboutTerumaUiModel? {

        // 1️⃣ Remote Config
        val config = getRemoteConfigObjectUseCase<AboutTerumaConfig>(
            remoteConfig = RemoteConfig.TERUMA
        ) ?: return null

        if (!config.enabled) return null

        // 2️⃣ Time gate (minutes -> millis)
        val gateResult = timeGateUseCase(
            requiredMinutesOverride = config.minutes
        )

        if (gateResult !is TimeGateResult.Allowed) {
            return null
        }

        // 3️⃣ UI-ready model
        return AboutTerumaUiModel(
            text = config.text.trim(),
            ctaText = config.ctaText.trim(),
            url = config.url,
        )
    }
}
